module.exports = __webpack_public_path__ + "fonts/nexa-bold-webfont.bb7c8ca8.woff2";